import { bigNumberMinus, bigNumberPlus } from '../utils/number';

const USERTRADES_LIMIT = 40;

export const handleMarginUpdateExecute = (state, execute) => {
  const newState = {
    ...state,
    marginOpenOrders: [...(state.marginOpenOrders || [])],
    marginTradeOrders: [...(state.marginTradeOrders || [])],
    userTrades: { ...(state.userTrades || {}) },
  };

  if (state.tickers?.[execute.symbol]) {
    const i18n = state.localeData[state.locale] || {};
    const order = {};
    order.symbol = execute.symbol;

    order.time = execute.time;
    order.side = execute.side;
    order.type = execute.orderType;
    order.status = execute.orderStatus;
    order.workingIndicator = execute.workingIndicator;
    order.origQty = Number(execute.qty);
    order.price = Number(execute.price);
    order.stopPrice = Number(execute.stopPrice);
    order.executedQty = Number(execute.cummulativeQty);
    order.commissionAsset = Number(execute.commissionAsset);
    order.orderId = execute.orderId;
    order.orderListId = execute.orderListId;
    order.orderType = i18n[`exchange-common-${execute.orderType.toLocaleLowerCase()}`] || execute.orderType;
    order.baseAsset = state.tickers[order.symbol].ba;
    order.quoteAsset = state.tickers[order.symbol].qa;
    const lastQty = parseFloat(execute.lastQty);
    const lastPrice = parseFloat(execute.lastPrice);
    const executedQty = parseFloat(execute.cummulativeQty);

    if (order.orderType === 'STOP_LOSS_LIMIT' || order.orderType === 'TAKE_PROFIT_LIMIT') {
      order.orderType = i18n['exchange-common-stopLimit'];
    }
    if (__DEV__) console.log(`orderStatus = ${execute.orderStatus}`);
    switch (execute.orderStatus) {
      case 'NEW': {
        order.executedQty = 0;
        order.executedPrice = 0;
        order.avgPrice = 0;
        if (order.type === 'LIMIT' || order.type === 'MARKET' || order.type === 'LIMIT_MAKER') {
          if (__DEV__) console.log('NEW insert marginOpenOrders =', order);
          newState.marginOpenOrders.unshift(order);
        } else if (order.type === 'STOP_LOSS_LIMIT' || order.type === 'TAKE_PROFIT_LIMIT') {
          if (!order.workingIndicator) { // 未激活
            if (__DEV__) console.log('NEW insert marginOpenOrders =', order);
            newState.marginOpenOrders.unshift(order);
          } else {
            newState.marginOpenOrders.forEach((value, index) => {
              if (order.orderId === value.orderId && order.symbol === value.symbol) {
                newState.marginOpenOrders[index] = {
                  ...newState.marginOpenOrders[index],
                  workingIndicator: order.workingIndicator,
                };
              }
            });
          }
        }
        break;
      }
      case 'PARTIALLY_FILLED': {
        newState.marginOpenOrders.forEach((o, index) => {
          if (o.symbol === order.symbol && o.orderId === order.orderId) {
            // 更新 委托
            const onew = {};
            onew.avgPrice = onew.executedPrice =
              ((o.executedQty * (o.executedPrice || o.avgPrice)) + (lastPrice * lastQty))
              / executedQty;

            onew.executedQty = executedQty;
            onew.executedQuoteQty = onew.executedPrice * onew.executedQty;
            onew.status = i18n['exchange-common-partiallyFilled'];
            newState.marginOpenOrders[index] = { ...o, ...onew };

            if (__DEV__) console.log('PARTIALLY_FILLED update marginOpenOrders =', { ...o, ...onew });
          }
        });

        // 添加当天成交
        const deal = {};
        deal.a = order.orderId;
        deal.s = order.symbol;
        deal.T = order.time;
        deal.d = order.side;
        deal.q = lastQty;
        deal.p = lastPrice;
        deal.ba = state.tickers[order.symbol].ba;
        deal.qa = state.tickers[order.symbol].qa;
        deal.f = parseFloat(execute.commission);
        deal.tq = lastQty * lastPrice;
        deal.fa = execute.commissionAsset;
        deal.m = execute.isMaker;

        newState.userTrades[order.symbol] = [deal, ...(newState.userTrades[order.symbol] || [])];
        if (newState.userTrades[order.symbol].length > USERTRADES_LIMIT) {
          newState.userTrades[order.symbol].length = USERTRADES_LIMIT;
        }

        newState.userTradesWithoutSymbol = [deal, ...(newState.userTradesWithoutSymbol || [])];
        if (__DEV__) console.log('FILLED get marginTradeOrders =', deal);

        break;
      }
      case 'FILLED': {
        let historyOrder;

        newState.marginOpenOrders.forEach((o) => {
          if (o.symbol === execute.symbol && o.orderId === execute.orderId) {
            // 更新 委托
            const onew = {};
            onew.executedPrice =
              ((o.executedQty * o.executedPrice) + (lastPrice * lastQty)) / executedQty;
            onew.executedQty = executedQty;
            onew.status = i18n['exchange-common-filled'];
            onew.executedQuoteQty = onew.executedPrice * onew.executedQty;
            onew.type = o.type;
            historyOrder = { ...o, ...onew };
            if (__DEV__) console.log('FILLED get historyOrder =', { ...o, ...onew });
          }
        });
        newState.marginTradeOrders.unshift(historyOrder);
        // 添加当天成交
        const deal = {};
        deal.a = order.orderId;
        deal.s = order.symbol;
        deal.T = order.time;
        deal.d = order.side;
        deal.q = lastQty;
        deal.p = lastPrice;
        deal.ba = state.tickers[order.symbol].ba;
        deal.qa = state.tickers[order.symbol].qa;
        deal.f = parseFloat(execute.commission);
        deal.tq = lastQty * lastPrice;
        deal.fa = execute.commissionAsset;
        deal.m = execute.isMaker;

        newState.userTrades[order.symbol] = [deal, ...(newState.userTrades[order.symbol] || [])];
        if (newState.userTrades[order.symbol].length > USERTRADES_LIMIT) {
          newState.userTrades[order.symbol].length = USERTRADES_LIMIT;
        }

        newState.userTradesWithoutSymbol = [deal, ...(newState.userTradesWithoutSymbol || [])];
        if (__DEV__) console.log('FILLED get marginTradeOrders =', deal);

        let orderIndex = -1;
        newState.marginOpenOrders.forEach((o, index) => {
          if (o.symbol === order.symbol && o.orderId === order.orderId) {
            orderIndex = index;
          }
        });
        // 删除 委托
        newState.marginOpenOrders.splice(orderIndex, 1);
        if (__DEV__) console.log('FILLED delet marginTradeOrders =', newState.marginOpenOrders[orderIndex]);
        break;
      }
      case 'CANCELED': {
        let orderIndex1 = -1;
        let historyOrder1;
        newState.marginOpenOrders.forEach((o, index) => {
          if (o.symbol === order.symbol && o.orderId === order.orderId) {
            orderIndex1 = index;
            const onew = {};
            if (executedQty === 0) {
              onew.executedPrice = 0;
              onew.status = i18n['exchange-common-canceled'];
              if (order.type === 'MARKET') {
                onew.status = i18n['exchange-common-expired'];
              }
              onew.executedQuoteQty = 0;
            } else {
              onew.executedPrice =
                ((o.executedQty * (o.executedPrice || o.avgPrice)) + (lastPrice * lastQty))
                / executedQty;
              onew.executedQty = executedQty;
              onew.status = i18n['exchange-common-partiallyFilled'];
              onew.executedQuoteQty = onew.executedPrice * onew.executedQty;
            }
            historyOrder1 = { ...o, ...onew };
          }
        });
        if (__DEV__) {
          console.log(`${order.status} delet index=${orderIndex1} marginOpenOrders =`,
            newState.marginOpenOrders[orderIndex1]
          );
        }

        newState.marginOpenOrders.splice(orderIndex1, 1);
        if (__DEV__) console.log(`${order.status}  insert marginTradeOrders =`, historyOrder1);
        newState.marginTradeOrders.unshift(historyOrder1);
        break;
      }

      case 'EXPIRED': {
        let orderIndex1 = -1;
        let historyOrder1;
        newState.openOrders.forEach((o, index) => {
          if (o.symbol === order.symbol && o.orderId === order.orderId) {
            orderIndex1 = index;
            const onew = {};
            if (executedQty === 0) {
              onew.executedPrice = 0;
              onew.status = i18n['exchange-common-expired'];
              onew.executedQuoteQty = 0;
            } else {
              console.log(`${executedQty} not equal 0`);
            }
            historyOrder1 = { ...o, ...onew };
          }
        });
        if (__DEV__) {
          console.log(`${order.status} delet index=${orderIndex1} openOrders =`,
            newState.openOrders[orderIndex1]
          );
        }
        newState.openOrders.splice(orderIndex1, 1);
        if (__DEV__) console.log(`${order.status}  insert tradeOrders =`, historyOrder1);
        newState.tradeOrders.unshift(historyOrder1);
        break;
      }

      case 'REJECTED': {
        // TODO
        break;
      }

      default:

        break;
    }

    return newState;
  }
  return newState;
};

export const handleUpdateMarginAccoutInfo = (state, balances) => {
  const { marginAccount: { userAssets, marginFreeAssets, debtMap } } = state;
  const keys = userAssets.reduce((acc, cur) => {
    const { asset: key } = cur;
    acc[key] = key;
    return acc;
  }, {});
  const tmp = balances[0].B.filter(item => keys[item.a]);
  const newState = {
    ...state,
    marginAccount: {
      ...state.marginAccount, userAssets: [...userAssets], marginFreeAssets: { ...marginFreeAssets }, debtMap,
    },
  };
  if (userAssets.length) {
    tmp.forEach(bal => {
      userAssets.forEach((obj, index) => {
        if (bal.a === obj.asset) {
          const arr = newState.marginAccount.userAssets[index];
          const totalAmount = bigNumberPlus(bal.f, bal.l);
          const netAsset = bigNumberMinus(totalAmount, debtMap[bal.a]);
          newState.marginAccount.userAssets[index] = {
            ...arr, free: bal.f, locked: bal.l, totalAmount, netAsset,
          };
          newState.marginAccount.marginFreeAssets[bal.a] = bal.f;
        }
      });
    });
  }
  return newState;
};
